<ng-template [ngIf]="meetingReviews?.length">
  <section class="reviews-carousel"
           [class.mobile]="deviceService.isMobile()">

    <ng-template [ngIf]="meetingReviews?.length > 1">
      <div class="left-action" (click)="onMoveLeft()">
        <app-icon class="icon" icon="drag-scroll-arrow"></app-icon>
      </div>

      <div class="right-action" (click)="onMoveRight()">
        <app-icon class="icon" icon="drag-scroll-arrow"></app-icon>
      </div>
    </ng-template>

    <div class="scroll" [class.with-scroll]="meetingReviews.length>1">
      <drag-scroll #dragScroll class="carousel-wrap" [snap-duration]="200">
        <div *ngFor="let review of meetingReviews; trackBy: trackByFn" drag-scroll-item class="reviews-item">
          <app-meeting-reviews-2 [review]="review"></app-meeting-reviews-2>
        </div>
      </drag-scroll>
    </div>
  </section>
</ng-template>
